
import { Component, Vue } from 'vue-property-decorator';
import { IMaterial } from '@/interfaces';
import { dispatchGetProduct, dispatchSetUpProduct } from '@/store/setup/actions';
import UploadButton from '@/components/UploadButton.vue';
import { dispatchGetFile, dispatchGetProductMaterial } from '@/store/report/actions';
import { IProduct, ISetUpProduct } from '@/store/setup';
import { commitAddNotification } from '@/store/main/mutations';
import { sizeLimit } from '@/utils/const';

@Component({
  components: {
    UploadButton,
  },
})
export default class Product extends Vue {
  public isSelecting = false;
  public fileClear = false;
  public materials: IMaterial[] = [];
  public deleteFileIds: number[] = [];

  public product_name: string = '';
  public product_url: string = '';
  public product_description: string = '';
  public product_materials: File[] = [];
  public material_error_messages: string[] = [];

  public async mounted() {
    this.reset();
  }

  public async reset() {
    this.materials = [];
    this.product_materials = [];
    this.deleteFileIds = [];
    this.material_error_messages = [];

    const product = await dispatchGetProduct(this.$store);
    if (product) {
      if (product.product_name) {
        this.product_name = product.product_name;
      }
      if (product.product_url) {
        this.product_url = product.product_url;
      }
      if (product.product_description) {
        this.product_description = product.product_description;
      }
      if (product.product_materials.length > 0) {
        this.materials = Array.from(product.product_materials);
      }
    }
    this.$validator.reset();
  }

  public back() {
    this.$router.back();
  }

  public async download(id: number, file_name: string) {
    await dispatchGetProductMaterial(this.$store, { "id": id, "file_name": file_name });
  }

  public getFile(file: File, file_name: string) {
    dispatchGetFile(this.$store, { file: file, file_name: file_name });
  }

  public uploadFiles(value) {
    this.product_materials.push(value[0]);
    this.fileClear = true;
    this.$nextTick(function () {
      this.fileClear = false;
    })
  }

  public deleteFile(uploaded: boolean, index: number) {
    if (uploaded) {
      this.deleteFileIds.push(this.materials[index].id);
      this.materials.splice(index, 1);
    } else {
      this.product_materials.splice(index, 1);
    }
  }

  public checkFileSize(): boolean {
    let bool = true;
    this.material_error_messages = [];
    for (let i = 0; i < this.product_materials.length; i++) {
      if (this.product_materials[i].size > sizeLimit) {
        this.material_error_messages.push(`ファイルサイズは100MB以下にしてください`);
        bool = false;
      } else {
        this.material_error_messages.push('');
      }
    }
    return bool;
  }

  public async save() {
    if (!this.checkFileSize()) {
      return;
    }
    const product: IProduct = {
      product_name: this.product_name,
      product_url: this.product_url,
      product_description: this.product_description,
      product_materials: this.materials
    };
    const setup_product: ISetUpProduct = {
      product: product,
      upload_files: this.product_materials,
      delete_file_ids: this.deleteFileIds,
    }
    await dispatchSetUpProduct(this.$store, setup_product);
    commitAddNotification(this.$store, { content: '保存されました', condition: 'saved' });
    this.reset();
  }

  public async submit() {
    if (!this.checkFileSize()) {
      return;
    }
    if (await this.$validator.validateAll()) {
      const product: IProduct = {
        product_name: this.product_name,
        product_url: this.product_url,
        product_description: this.product_description,
        product_materials: this.materials,
      };
      const setup_product: ISetUpProduct = {
        product: product,
        upload_files: this.product_materials,
        delete_file_ids: this.deleteFileIds,
      }
      await dispatchSetUpProduct(this.$store, setup_product);
      this.$router.push('/setup/finance');
    }
  }

  get isComplete() {
    return this.product_name
      && ((this.materials.length > 0 || this.product_materials.length > 0)
        || this.product_description);
  }
}
